import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useParams } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

function FormularioTemperaturaHumedad() {
    const { id } = useParams();
    const history = useHistory();
    const modoEdicion = !!id;

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [areas, setAreas] = useState([]);
    
    // Campos del formulario
    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
    const [hora, setHora] = useState(new Date().toTimeString().split(' ')[0].substring(0, 5));
    const [temperatura, setTemperatura] = useState('');
    const [humedad, setHumedad] = useState('');
    const [responsableId, setResponsableId] = useState('');
    const [localizacionId, setLocalizacionId] = useState('');
    const [observacionesGenerales, setObservacionesGenerales] = useState('');
    const [analisisCondicionesAmbientales, setAnalisisCondicionesAmbientales] = useState('');
    const [accionesTomadasDesviaciones, setAccionesTomadasDesviaciones] = useState('');
    
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const permisoRequerido = 'gestionarTemperaturaHumedad';
        const tienePermiso = userdata.up && userdata.up.includes(permisoRequerido);
        
        if (!tienePermiso) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Usar endpoint optimizado que solo trae id, name, lastname
        axios.get('/usuarios-basico')
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                    // Si no está en modo edición, seleccionar el usuario actual por defecto
                    if (!modoEdicion && response.data.length > 0) {
                        const usuarioActual = response.data.find(u => u.id === userdata.user_id);
                        if (usuarioActual) {
                            setResponsableId(usuarioActual.id);
                        }
                    }
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/areas-localizacion')
            .then(response => {
                if (response.status === 200) {
                    setAreas(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Si está en modo edición, cargar los datos del registro
        if (modoEdicion) {
            cargarRegistro();
        }
    }, [id, modoEdicion]);

    const cargarRegistro = () => {
        axios.get(`/registro-temperatura-humedad/${id}`)
            .then(response => {
                if (response.status === 200) {
                    const registro = response.data;
                    setFecha(registro.fecha);
                    setHora(registro.hora);
                    setTemperatura(registro.temperatura);
                    setHumedad(registro.humedad);
                    setResponsableId(registro.responsable_id);
                    setLocalizacionId(registro.localizacion_id);
                    setObservacionesGenerales(registro.observaciones_generales || '');
                    setAnalisisCondicionesAmbientales(registro.analisis_condiciones_ambientales || '');
                    setAccionesTomadasDesviaciones(registro.acciones_tomadas_desviaciones || '');
                }
            })
            .catch(error => {
                console.error('Error al cargar registro:', error);
                alert('Error al cargar el registro');
                history.push('/registros-temperatura-humedad');
            });
    };

    const validarFormulario = () => {
        if (!fecha) {
            alert('Por favor seleccione una fecha');
            return false;
        }

        if (!hora) {
            alert('Por favor seleccione una hora');
            return false;
        }

        if (!temperatura || temperatura === '') {
            alert('Por favor ingrese la temperatura');
            return false;
        }

        const tempNum = parseFloat(temperatura);
        if (isNaN(tempNum) || tempNum < -50 || tempNum > 100) {
            alert('La temperatura debe estar entre -50°C y 100°C');
            return false;
        }

        if (!humedad || humedad === '') {
            alert('Por favor ingrese la humedad');
            return false;
        }

        const humNum = parseFloat(humedad);
        if (isNaN(humNum) || humNum < 0 || humNum > 100) {
            alert('La humedad debe estar entre 0% y 100%');
            return false;
        }

        if (!localizacionId) {
            alert('Por favor seleccione un área/localización');
            return false;
        }

        if (!responsableId) {
            alert('Por favor seleccione un responsable');
            return false;
        }

        return true;
    };

    const guardarRegistro = async () => {
        if (!validarFormulario()) {
            return;
        }

        setGuardando(true);

        // Asegurar formato correcto de hora (HH:MM:SS)
        let horaFormateada = hora;
        if (hora.split(':').length === 2) {
            // Si solo tiene HH:MM, agregar :00
            horaFormateada = hora + ':00';
        }

        const datos = {
            fecha,
            hora: horaFormateada,
            temperatura: parseFloat(temperatura),
            humedad: parseFloat(humedad),
            responsable_id: parseInt(responsableId),
            localizacion_id: parseInt(localizacionId),
            observaciones_generales: observacionesGenerales,
            analisis_condiciones_ambientales: analisisCondicionesAmbientales,
            acciones_tomadas_desviaciones: accionesTomadasDesviaciones
        };

        try {
            if (modoEdicion) {
                await axios.put(`/registro-temperatura-humedad/${id}`, datos);
                alert('Registro actualizado exitosamente');
            } else {
                await axios.post('/registro-temperatura-humedad', datos);
                alert('Registro creado exitosamente');
            }
            
            history.push('/registros-temperatura-humedad');
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar: ' + (error.response?.data?.message || error.message));
        } finally {
            setGuardando(false);
        }
    };

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="indicators" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/indicadores">Indicadores</Link></li>
                                        <li className="breadcrumb-item"><Link to="/registros-temperatura-humedad">Temperatura y Humedad</Link></li>
                                        <li className="breadcrumb-item">{modoEdicion ? 'Editar' : 'Nuevo'} Registro</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <h1 className="m-0">
                                        <i className="fas fa-thermometer-half mr-2"></i>
                                        {modoEdicion ? 'Editar' : 'Nuevo'} Registro de Temperatura y Humedad
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h5><b>Datos del Registro</b></h5>
                                </div>
                                <div className="card-body">
                                    
                                    {/* Fecha y Hora */}
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Fecha *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fecha}
                                                    onChange={(e) => setFecha(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Hora *</label>
                                                <input 
                                                    type="time" 
                                                    className="form-control" 
                                                    value={hora}
                                                    onChange={(e) => setHora(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Temperatura y Humedad */}
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Temperatura (°C) *</label>
                                                <div className="input-group">
                                                    <input 
                                                        type="number" 
                                                        className="form-control" 
                                                        placeholder="Ej: 22.5"
                                                        value={temperatura}
                                                        onChange={(e) => setTemperatura(e.target.value)}
                                                        step="0.1"
                                                        min="-50"
                                                        max="100"
                                                        required
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">°C</span>
                                                    </div>
                                                </div>
                                                <small className="form-text text-muted">Rango: -50°C a 100°C</small>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Humedad (%) *</label>
                                                <div className="input-group">
                                                    <input 
                                                        type="number" 
                                                        className="form-control" 
                                                        placeholder="Ej: 65.0"
                                                        value={humedad}
                                                        onChange={(e) => setHumedad(e.target.value)}
                                                        step="0.1"
                                                        min="0"
                                                        max="100"
                                                        required
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">%</span>
                                                    </div>
                                                </div>
                                                <small className="form-text text-muted">Rango: 0% a 100%</small>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Área/Localización y Responsable */}
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Área/Localización *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={localizacionId}
                                                    onChange={(e) => setLocalizacionId(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {areas.map(area => (
                                                        <option key={area.id} value={area.id}>
                                                            {area.area_localizacion}
                                                        </option>
                                                    ))}
                                                </select>
                                                {areas.length === 0 && (
                                                    <small className="form-text text-warning">
                                                        <i className="fas fa-exclamation-triangle"></i> No hay áreas configuradas. 
                                                        <Link to="/areas-localizacion" className="ml-1">Crear área</Link>
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Responsable *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={responsableId}
                                                    onChange={(e) => setResponsableId(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {usuarios.map(usuario => (
                                                        <option key={usuario.id} value={usuario.id}>
                                                            {usuario.name} {usuario.lastname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <hr/>

                                    {/* Observaciones Generales */}
                                    <div className="form-group">
                                        <label>Observaciones Generales</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            placeholder="Ingrese observaciones generales sobre las condiciones..."
                                            value={observacionesGenerales}
                                            onChange={(e) => setObservacionesGenerales(e.target.value)}
                                        ></textarea>
                                    </div>

                                    {/* Análisis de Condiciones Ambientales */}
                                    <div className="form-group">
                                        <label>Análisis de Condiciones Ambientales</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            placeholder="Análisis de las condiciones ambientales registradas..."
                                            value={analisisCondicionesAmbientales}
                                            onChange={(e) => setAnalisisCondicionesAmbientales(e.target.value)}
                                        ></textarea>
                                    </div>

                                    {/* Acciones Tomadas frente a Desviaciones */}
                                    <div className="form-group">
                                        <label>Acciones Tomadas frente a Desviaciones</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            placeholder="Describa las acciones tomadas en caso de desviaciones..."
                                            value={accionesTomadasDesviaciones}
                                            onChange={(e) => setAccionesTomadasDesviaciones(e.target.value)}
                                        ></textarea>
                                    </div>

                                </div>
                                <div className="card-footer">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Link 
                                                to="/registros-temperatura-humedad" 
                                                className="btn btn-secondary"
                                            >
                                                <i className="fas fa-times"></i> Cancelar
                                            </Link>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button 
                                                className="btn btn-info" 
                                                onClick={guardarRegistro}
                                                disabled={guardando}
                                            >
                                                {guardando ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i> Guardando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-save"></i> {modoEdicion ? 'Actualizar' : 'Guardar'} Registro
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default FormularioTemperaturaHumedad;
